// The current page's name-free title, from the last navigation event.
// Plain ES2015 + object spread: classic's Babel 6 build bundles this file.
let pageTitle = null;

export function setAnalyticsPageTitle(title) {
  pageTitle = title || null;
}

/**
 * Segment source middleware that keeps record names out of analytics.
 * analytics.js copies document.title, which leads with the open record's name,
 * into every event's context.page.title; this swaps in the navigation title.
 * The context is replaced, never edited, as it may be an object the app passed
 * in; payload itself goes on as-is, since Segment's chain relies on its methods.
 */
export function stampAnalyticsPageTitle({ payload, next }) {
  if (pageTitle) {
    const context = payload.obj.context || {};
    payload.obj.context = {
      ...context,
      page: { ...context.page, title: pageTitle }
    };
  }
  next(payload);
}
